import { Directive, TemplateRef } from '@angular/core';
var NglFormLabelTemplate = (function () {
    function NglFormLabelTemplate(templateRef) {
        this.templateRef = templateRef;
    }
    NglFormLabelTemplate.decorators = [
        { type: Directive, args: [{ selector: '[nglFormLabel]' },] },
    ];
    /** @nocollapse */
    NglFormLabelTemplate.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return NglFormLabelTemplate;
}());
export { NglFormLabelTemplate };
export function getFormLabel(label, labelTemplate) {
    if (label)
        return label;
    return labelTemplate ? labelTemplate.templateRef : '';
}
//# sourceMappingURL=form-label.js.map